import { categories } from "@/mocks/categories";

export const getCategoryName = (slug: string): string =>
  categories.find((item) => item.slug === slug)?.name ?? "综合";

export const getCategoryIcon = (slug: string): string =>
  categories.find((item) => item.slug === slug)?.icon ?? "ri-article-line";

export const formatHeat = (value: number): string => {
  if (value >= 10000) return `${(value / 10000).toFixed(1)} 万`;
  return `${value}`;
};

export const accentClass: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: "bg-primary-100",
    text: "text-primary-700",
    border: "border-primary-200",
  },
  accent: {
    bg: "bg-accent-100",
    text: "text-accent-800",
    border: "border-accent-200",
  },
  secondary: {
    bg: "bg-secondary-100",
    text: "text-secondary-800",
    border: "border-secondary-200",
  },
};